import React, { useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment-timezone";
import HighchartsCustomEvents from "highcharts-custom-events";
import { numberWithCommas, mFormatter, kmFormatter } from "../../../../../../MainContent/Dashboard/Charts/utils";
import ResizeObserver from "resize-observer-polyfill";
HighchartsCustomEvents(Highcharts);
function ProfileViewsOverTimeChart(props) {
    const lineChartData = props?.chartData?.lineChartData || [];
    let tzo = JSON.parse(localStorage.company).user_timezone * -60;
    let chartComponent = useRef(null);
    const legendAlign = props.isIGPage ? "right" : "center";
    useEffect(() => {
        let ro = null;
        // if (!props.isIGPage) {
        ro = new ResizeObserver(() => {
            chartComponent?.current?.chart?.setSize(null, null);
            chartComponent?.current?.chart?.reflow();
        });
        if (props.widgetContainerRef?.current) {
            ro.observe(props.widgetContainerRef?.current);
        }
        // }
        return () => {
            // if (!props.isIGPage) {
            ro.disconnect();
            // }
        };
    }, []);

    const chartOptions = {
        chart: {
            type: props.graphType == "line" ? "spline" : "column",
            backgroundColor: "transparent",
            style: {
                fontFamily: "'Roboto', sans-serif",
                fontSize: 12,
            },
        },
        credits: {
            enabled: false,
        },
        lang: {
            noData: "No data.",
        },
        noData: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                color: "#303030",
            },
            position: {
                align: "center",
            },
        },
        title: {
            text: " ",
        },
        xAxis: {
            lineColor: "#ccd6eb",
            lineWidth: 1,
            type: "datetime",
            dateTimeLabelFormats: {
                millisecond: "%l:%M:%S.%L %p",
                second: "%l:%M:%S %p",
                minute: "%l:%M %p",
                hour: "%l:%M %p",
                day: "%e %b",
                week: "%e. %b",
                month: "%b '%y",
                year: "%Y",
            },
            labels: {
                style: {
                    textTransform: "normal",
                },
            },
        },
        yAxis: {
            gridLineWidth: props.showGridLines ? 2 : 0,

            gridLineDashStyle: "ShortDash",
            gridLineColor: "#ccd6eb",
            lineColor: "#ccd6eb",
            lineWidth: 1,
            allowDecimals: false,
            title: {
                text: ``,
            },
        },
        series: [{ name: "Views", data: lineChartData, color: "#bfd834" }],
        legend: {
            enabled: props.showLegend,
            align: legendAlign,
            itemStyle: {
                fontWeight: 500,
                fontFamily: "'Roboto', sans-serif",
                textTransform: "normal",
            },
            alignColumns: false,
        },

        plotOptions: {},
        tooltip: {
            formatter: function () {
                return `${moment(this.x).format("LLLL")}<br/>Views Count: <b>${numberWithCommas(this.y)}</b>`;
            },

            backgroundColor: "#fff",
            borderRadius: 6,
        },
        time: {
            timezoneOffset: tzo,
        },
    };
    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={chartOptions}
            ref={chartComponent}
            containerProps={{ style: { width: "100%", height: props.isIGPage ? "calc(100%)" : "calc(100% - 10px)" } }}
        />
    );
}

export default ProfileViewsOverTimeChart;
